import React from 'react';
import '../../styles/republic-day.css';

/**
 * Republic Day Flag Animation component - animated tricolor elements
 * Creates subtle waving tricolor effects
 */
const FlagAnimation = () => {
  return (
    <div className="flag-animation-container" aria-hidden="true">
      {/* Multiple Floating Ashoka Chakras with rotation */}
      <div className="floating-chakra chakra-1">
        <span className="chakra-symbol">☸</span>
      </div>
      <div className="floating-chakra chakra-2">
        <span className="chakra-symbol">☸</span>
      </div>
      <div className="floating-chakra chakra-3">
        <span className="chakra-symbol">☸</span>
      </div>
      <div className="floating-chakra chakra-4">
        <span className="chakra-symbol">☸</span>
      </div>
      <div className="floating-chakra chakra-5">
        <span className="chakra-symbol">☸</span>
      </div>
      
      {/* Decorative tricolor circles */}
      <div className="tricolor-circles">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>
      
      {/* Enhanced sparkle effects */}
      <div className="sparkle-container">
        {Array.from({ length: 35 }, (_, i) => (
          <div
            key={i}
            className="sparkle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${1.5 + Math.random() * 3}s`,
            }}
          >
            ✨
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlagAnimation;
